































































import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import LocalityMixin from "@/mixins/http/LocalityMixin";

@Component({ components: { VModal, VSelect } })
export default class MediumAudienceBatchModal extends Mixins(LocalityMixin) {
  audience = 0;
  selectedRegion = "";
  regionItems: VSelectOption[] = [];
  selectedDistrict = "";
  districtItems: VSelectOption[] = [];
  selectedTown = "";
  townItems: VSelectOption[] = [];

  postalCode = "";

  @Ref() readonly modal!: VModal;

  @Watch("selectedRegion", { immediate: true })
  async onRegionChanged(value: string) {
    this.districtItems = [];
    this.townItems = [];
    this.selectedDistrict = "";
    this.selectedTown = "";
    this.postalCode = "";
    const districts = await this.getDistricts(value);
    this.districtItems = districts
      .map((el) => {
        return {
          id: el.id,
          text: el.name,
        };
      })
      .sort((a, b) => {
        if (a.text < b.text) {
          return -1;
        } else if (a.text > b.text) {
          return 1;
        }
        return 0;
      });
  }

  @Watch("selectedDistrict", { immediate: true })
  async onDistrictChanged(value: string) {
    this.townItems = [];
    this.selectedTown = "";
    this.postalCode = "";
    const towns = await this.getTowns(value);
    this.townItems = towns
      .map((el) => {
        return {
          id: el.id,
          text: el.name,
        };
      })
      .sort((a, b) => {
        if (a.text < b.text) {
          return -1;
        } else if (a.text > b.text) {
          return 1;
        }
        return 0;
      });
  }

  async created() {
    const regions = await this.getRegions();
    this.regionItems = regions
      .map((el) => {
        return {
          id: el.id,
          text: el.name,
        };
      })
      .sort((a, b) => {
        if (a.text < b.text) {
          return -1;
        } else if (a.text > b.text) {
          return 1;
        }
        return 0;
      });
  }

  show() {
    this.modal.show();
    this.postalCode = "";
    this.selectedRegion = "";
    this.selectedDistrict = "";
    this.selectedTown = "";
    this.audience = 0;
  }

  close() {
    this.modal.hide();
  }

  onCancel() {
    this.close();
  }

  onSave() {
    if (this.postalCode) {
      this.$emit("save", {
        audience: this.audience,
        postalCode: this.postalCode,
      });
    } else {
      const region =
        this.regionItems.find((el) => el.id === this.selectedRegion) ||
        undefined;
      const district =
        this.districtItems.find((el) => el.id === this.selectedDistrict) ||
        undefined;
      const town =
        this.townItems.find((el) => el.id === this.selectedTown) || undefined;
      this.$emit("save", {
        audience: this.audience,
        region: region?.text,
        district: district?.text,
        town: town?.text,
      });
    }
  }
}
